/** "1.2.3" / "v0.7.4" / "1.2.3-rc1" -> [1, 2, 3]; null if not dotted integers.
 *  Same rule as the server's parse_version, so "below" means the same on both. */
export const parseVersion = (version?: string | null): number[] | null => {
  if (!version) return null;
  const core = version.trim().replace(/^v/, "").split("-")[0].split("+")[0];
  const parts = core.split(".");
  if (!parts.every((p) => /^\d+$/.test(p))) return null;
  return parts.map(Number);
};

export const compareVersions = (a: number[], b: number[]): number => {
  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    const diff = (a[i] ?? -1) - (b[i] ?? -1);
    if (diff !== 0) return diff;
  }
  return 0;
};

/** Whether `version` is at least `minimum`; false if it cannot be parsed. */
export const isVersionAtLeast = (version: string | null | undefined, minimum: string): boolean => {
  const parsed = parseVersion(version);
  const min = parseVersion(minimum);
  return parsed !== null && min !== null && compareVersions(parsed, min) >= 0;
};
